// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1Kytq","col":"CardReaderDesc_col__-a3vz","label":"CardReaderDesc_label__21L4S"};